/**
 * @generated SignedSource<<55fbe2748526e75981f426eec0478bc1>>
 * @relayHash e24db43d988f741feb864de9d030d8b3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 35055626fdcdf8638a7db95abc40e3d8c040cad0855ab8f4fce5bbd552343a37

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { RecommendedTabEntryPointRootQuery } from './RecommendedTabEntryPointRootQuery.graphql';

import isForYouNewUsersEnabled_provider from '@jira/platform__graphql-relay-provider/src/JiraForYouLandAllNewUsersRelayProvider';
import isJiraFyRecommendedAssignAgentEnabled_provider from '@jira/platform__graphql-relay-provider/src/JiraFyRecommendedAssignAgentRelayProvider';
import isHexagonSupportEnabled_provider from '@jira/platform__graphql-relay-provider/src/hexagon-support.relayprovider';

const node: PreloadableConcreteRequest<RecommendedTabEntryPointRootQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "35055626fdcdf8638a7db95abc40e3d8c040cad0855ab8f4fce5bbd552343a37",
    "metadata": {},
    "name": "RecommendedTabEntryPointRootQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraFyRecommendedAssignAgentRelayProvider": isJiraFyRecommendedAssignAgentEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrcJiraForYouLandAllNewUsersRelayProvider": isForYouNewUsersEnabled_provider,
      "__relay_internal__pv__jiraplatform__graphqlrelayprovidersrchexagonsupportrelayprovider": isHexagonSupportEnabled_provider
    }
  }
};

export default node;
